var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"event-popup-company-logo",attrs:{"src":_vm.companyLogoUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }